

















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Moves extends Vue {
  @Prop({ required: true }) data!: string[];
}
